"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewslettersPlugin = void 0;
const base_1 = require("../base");
class NewslettersPlugin extends base_1.BasePlugin {
    constructor() {
        super(...arguments);
        this.defaultConfig = {
            injectOn: ['A'],
            maxInjections: 1,
            visibleOn: ['A', 'B', 'C', 'D'],
        };
    }
    generateMarkup(config, contextConfig) {
        const { breakpoint } = contextConfig;
        const { id } = config;
        const data = JSON.stringify({ id, breakpoint }).replace(/"/g, '&quot;');
        return `<div
            data-smart-slot="newsletters"
            data-smart-slot-config="${data}"
        ></div>`;
    }
}
exports.NewslettersPlugin = NewslettersPlugin;
//# sourceMappingURL=index.js.map